import { useTheme } from '@ytl/common-web';
import { MutableRefObject, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import { useOpenAm } from '../contexts/openAmContext';
import { BorgMigration } from '../partials/BorgMigration';
import { LoginDeviceCode } from '../partials/LoginDeviceCode';
import { LoginFrame } from '../partials/LoginFrame';
import { LoginWithEmailAndSms } from '../partials/LoginWithEmailAndSMS';
import { MfaAuthenticatorCode } from '../partials/MFAAuthenticatorCode';
import { LoginView } from '../shared/@types/OpenAmStage';

export const LoginPage = () => {
  const { stage } = useOpenAm();
  const view = stage.view;

  const isMfaView = useMemo(() => [LoginView.MFAAuthenticatorCode, LoginView.MFASMSCode].includes(view), [view]);
  const isDeviceCode = useMemo(() => [LoginView.DeviceCode, LoginView.DeviceCodeSuccess].includes(view), [view]);
  const displayFrame = ![LoginView.MFAAuthenticatorCode, LoginView.MFASMSCode, LoginView.YoloOtpStage].includes(view);
  const { isWebView } = useTheme();
  const prevIsWebViewRef: MutableRefObject<any> = useRef(null);

  const displayedView = useMemo(() => {
    switch (view) {
      case LoginView.Loader:
      case LoginView.LoginForm:
      case LoginView.SMSPhoneNumber:
      case LoginView.SMSCode:
      case LoginView.SMSCodeChange2FA:
      case LoginView.SMSNumberSelector:
      case LoginView.TestLogin:
      case LoginView.MSISDNCode:
        return <LoginWithEmailAndSms />;
      case LoginView.MFAAuthenticatorCode:
      case LoginView.MFASMSCode:
        return <MfaAuthenticatorCode />;
      case LoginView.YoloOtpStage:
        return <LoginWithEmailAndSms />;
      case LoginView.DeviceCode:
      case LoginView.DeviceCodeSuccess:
        return <LoginDeviceCode />;
      case LoginView.BorgMigration:
        return <BorgMigration />;
    }
  }, [view]);

  useEffect(() => {
    if (prevIsWebViewRef.current !== isWebView) {
      prevIsWebViewRef.current = isWebView;
    }
  }, [isWebView]);

  useLayoutEffect(() => {
    if (isMfaView) {
      document.body.classList.add('yui--mfa');
    } else {
      document.body.classList.remove('yui--mfa');
    }

    if (isDeviceCode) {
      document.body.classList.add('yui--devicecode');
    } else {
      document.body.classList.remove('yui--devicecode');
    }

    return () => {
      document.body.classList.remove('yui--mfa');
      document.body.classList.remove('yui--devicecode');
    };
  }, [isMfaView, isDeviceCode]);

  return (
    <>
      <div className={`frame${isMfaView || isDeviceCode ? ' frame--mfa' : ''}`}>
        {displayFrame && <LoginFrame />}

        <main className={`frame__content${isMfaView || isDeviceCode ? ' frame__content--mfa' : ''}`}>
          <div className="login-page">{displayedView}</div>
        </main>
      </div>
    </>
  );
};
